import { useCallback } from "react";
import { useSelector } from "react-redux";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { WithTranslator } from "Components/Generic/Translator";
import { IconButtonWithTooltip } from "Components/Generic/IconButtonWithTooltip";
import { selectLoginUsername } from "Store/Selectors/UI";
import { IUserProps } from "./IUserProps";
import { useUserStyles } from "./UseUserStyles";

export const User = WithTranslator((props: IUserProps): JSX.Element => {
  const {
    username, onEditUser, onRemove, translator
  } = props;
  const loginUsername = useSelector(selectLoginUsername);
  const allowDelete = username !== loginUsername;
  const styles = useUserStyles(allowDelete);

  const onRemoveUser = useCallback(() => onRemove(username), [onRemove, username]);
  const onClickUserName = useCallback(() => {
    if (!allowDelete) {
      return;
    }
    onEditUser(username);
  }, [allowDelete, onEditUser, username]);

  return (
    <Stack horizontal>
      <Stack.Item grow align="center" className={styles.name}>
        <Text block onClick={onClickUserName}>
          {username}
        </Text>
      </Stack.Item>
      <Stack.Item disableShrink>
        {allowDelete && (
          <IconButtonWithTooltip
            tooltip={translator.get(`generic.delete`, `Delete`)}
            iconProps={{ iconName: `trash` }}
            onClick={onRemoveUser}
          />
        )}
      </Stack.Item>
    </Stack>
  );
});
